module.exports = __webpack_public_path__ + "img/红心初级大师@2x.a89fd076.png";